import React, { useState } from 'react';

const TermsOfServicePage = ({ onAgree, onDecline }) => {
  const [hasViewedTerms, setHasViewedTerms] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  // 利用規約のPDFリンク
  const TERMS_URL = `${process.env.PUBLIC_URL}/assets/terms.pdf`;

  const handleViewTerms = () => {
    // 別タブで規約PDFを開く
    window.open(TERMS_URL, '_blank', 'noopener,noreferrer');
    // 規約を確認したフラグを立てる
    setHasViewedTerms(true);
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  return (
    <div className="flex flex-col h-screen bg-gray-50 font-sans items-center justify-center p-4">

      <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-md">

        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
          </div>
          <h1 className="text-xl font-bold text-gray-800">サービス利用規約</h1>
          <p className="text-sm text-gray-500 mt-2 text-start">
            サービスをご利用いただくには、利用規約への同意が必要です。
          </p>
        </div>

        <div className="space-y-6">

          {/* 規約確認ボタン */}
          <div>
            <button
              onClick={handleViewTerms}
              className="w-full py-3 px-4 bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold rounded-xl border border-gray-300 flex items-center justify-center transition-colors"
            >
              利用規約を確認する (PDF)
              <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
            </button>
            {!hasViewedTerms && (
              <p className="text-xs text-red-500 mt-2 text-center">
                ※規約を確認するとチェックできるようになります。
              </p>
            )}
          </div>

          {/* 同意チェックボックス */}
          <div className={`flex items-start ${hasViewedTerms ? 'opacity-100' : 'opacity-50'}`}>
            <div className="flex items-center h-5">
              <input
                id="terms"
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
                disabled={!hasViewedTerms}
                className="w-5 h-5 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 checked:bg-blue-600 checked:border-blue-600 cursor-pointer disabled:cursor-not-allowed"
              />
            </div>
            <label htmlFor="terms" className="ml-3 text-sm font-medium text-gray-700 cursor-pointer">
              利用規約の内容を確認し、同意します。
            </label>
          </div>

        </div>

        {/* アクションボタン */}
        <div className="mt-8 space-y-3">
          <button
            onClick={onAgree}
            disabled={!isChecked}
            className={`w-full py-3.5 rounded-xl font-bold text-white transition-all duration-300 ${isChecked
              ? 'ux-bg-red shadow-md transform active:scale-95'
              : 'ux-bg-gray cursor-not-allowed'
              }`}
          >
            はじめる
          </button>

          <button
            onClick={onDecline}
            className="w-full py-3.5 rounded-xl font-bold text-gray-500 hover:text-gray-700 bg-transparent transition-colors"
          >
            キャンセル
          </button>
        </div>

      </div>
    </div>
  );
};

export default TermsOfServicePage;